module.exports = __webpack_public_path__ + "img/tempfile1.7fcb790e.png";